<template>
  <div @mouseenter="mouseoverDirection" @mouseleave="mouseleaveDirection2"
       :class="lunBo == 0?'btn':lunBo == 1?'btn btn2':'btn btn3'"
       :style="direction?' background-color: white !important;opacity: 1; color: #12466e;':''">
    <div class="btnn">
      <div class="lang-box">
        <el-image v-show="lunBo ==2 && direction" :src="logoL"
                  style="height: 55px;width: 60px;margin-left: 10px"></el-image>
        <el-image v-show="lunBo ==2 && !direction" :src="logoB"
                  style="height: 55px;width: 60px;margin-left: 10px"></el-image>
        <el-image v-show="lunBo != 2" :src="logoB2"
                  style="height: 30px;width: 33px;padding-top: 2px;margin-left: 18px"></el-image>
      </div>
      <div class="lang-box2">
        <div @mouseenter="addBtnClass(index)" @mouseleave="removeBtnClass(index)" class="lang-box2-btn" ref="btnRef"
             v-for="(item,index) in store.state.navigationBar"
             @click="store.commit('gotoUrl',{url:item.url,bar:item.title,barTitleUrl:item.url})">
          <div
              :class="store.state.bar == item.url?'btnText2':'btnText animate__animated animate__faster__btn '">
            {{ item.title }}
          </div>
          <el-tooltip v-if="index == store.state.navigationBar.length-1" :show-arrow="false" placement="bottom"
                      effect="light">
            <div>
              <svg t="1718679241670" :class="lunBo ==2 && !direction?'icon2':'icon1'" viewBox="0 0 1070 1024"
                   version="1.1"
                   xmlns="http://www.w3.org/2000/svg" p-id="11216" width="30" height="30">
                <path
                    d="M232.582 358.133c12.288 36.33 32.59 67.851 60.905 95.633 24.042-26.18 42.207-58.235 53.96-95.633H232.583z"
                    p-id="11217"></path>
                <path
                    d="M981.615 143.36H532.836L507.192 6.055H90.468C44.522 6.055 7.123 43.453 7.123 89.4v708.43c0 45.946 37.399 83.344 83.345 83.344h379.86l-30.453 137.305h541.74c45.947 0 83.345-37.398 83.345-83.344v-708.43c0-45.947-37.398-83.345-83.345-83.345zM415.833 564.358c-49.152-18.165-89.756-41.139-122.346-67.852-34.192 30.453-76.933 52.892-126.62 66.783l-17.096-28.316c48.618-12.822 89.222-32.055 121.277-59.303-33.124-33.658-56.097-72.66-68.92-117.003h-46.48v-32.056h121.277c-7.48-13.89-17.096-27.247-28.316-40.07l32.056-11.753c11.22 14.425 21.37 31.522 30.453 51.29h115.935v32.055h-46.481c-14.96 45.946-36.33 84.413-64.646 115.4 31.522 25.11 71.057 45.947 117.538 63.043l-17.631 27.782zM1023.288 934.6c0 22.974-18.7 41.673-41.673 41.673H492.232l20.837-95.633h156.538l-89.222-497.397-0.534 2.671-3.74-19.767 1.069 0.534-32.59-181.649h437.56c22.973 0 41.672 18.7 41.672 41.673V934.6z"
                    p-id="11218"></path>
                <path
                    d="M684.566 541.384h114.866v-30.453H684.566v-60.905h122.346v-30.453H648.771V638.62h162.95v-30.453H684.565v-66.783zM924.45 475.67c-9.616 0-18.164 1.603-26.178 5.877-7.48 3.74-14.96 9.617-20.837 17.096v-18.699h-34.727V638.62h34.727v-95.633c1.069-12.822 5.343-22.439 12.823-29.384 6.41-5.877 13.89-9.083 22.439-9.083 24.041 0 35.795 12.823 35.795 39.001v94.565h34.727v-97.77c1.069-43.275-19.233-64.646-58.769-64.646z"
                    p-id="11219"></path>
              </svg>
            </div>
            <template #content>
              <div>
                <div @click="setZhongYing()" class="zi">English</div>
              </div>
            </template>
          </el-tooltip>
        </div>
      </div>
    </div>
  </div>
  <div @mouseleave="mouseleaveDirection" v-show="direction && direction2 !=0" class="zibtn"
       :style="lunBo == 1 ?'padding-top: 50px;':'padding-top: 90px;'">
    <div style="border-top: #989898 1px solid"></div>
    <div v-for="(item,index) in store.state.navigationBar" v-show="direction2 == index" class="zibtnDiv">
      <div v-if="store.state.navigationBar[index] != null"
           v-for="(item2,index2) in store.state.navigationBar[index].bar"
           :style="store.state.navigationBar[index].bar[index2].list != []?'width:100%;padding:0px;':''" class="zibtnD">
        <div
            @click="store.commit('gotoUrl',{url:item2.url,bar:store.state.navigationBar[index].title,barTitleUrl:item.url})"
            style="width: 100%;display: flex;align-items: center">
          <el-image class="you" :src="you"></el-image>
          <span class="barzi">{{ item2.name }}</span>
        </div>
        <div
            @click="store.commit('gotoUrl',{url:item3.url,bar:store.state.navigationBar[index].title,barTitleUrl:item.url})"
            class="barzi2" v-for="(item3,index3) in store.state.navigationBar[index].bar[index2].list">
          {{ item3.name }}
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import {inject, onMounted, defineEmits, defineProps, ref, reactive, getCurrentInstance, onDeactivated} from 'vue';
import {useRouter} from "vue-router";
import store from "@/store";
import logoB from '@/assets/logo/logo白.png'
import logoB2 from '@/assets/logo/logo白2.png'
import logoL from '@/assets/logo/logo蓝.png'
import you from '@/assets/you.png'
import zhong from '@/assets/中文.png'
import ying from '@/assets/英文.png'
import 'animate.css';

let direction = ref(false)
let direction2 = ref(0)
const router = useRouter();
let barList = ref([])
let lunBo = ref(0)
let btnRef = ref()

const setZhongYing = () => {
  window.location.href = (window.location.protocol + '//' + window.location.host +'/EN'+window.location.pathname  + window.location.search)
}

const mouseleaveDirection = () => {
  direction.value = false;
}
const mouseleaveDirection2 = () => {
  if (direction2.value == 0) {
    direction.value = false;
  }
}
const mouseoverDirection = () => {
  direction.value = true;
  direction2.value = 0;
}

const handleScroll = () => {
  let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
  if (scrollTop > 0) lunBo.value = 1;
  if (scrollTop == 0) lunBo.value = 2;
}
const addBtnClass = (index) => {
  direction2.value = index
  if (btnRef.value[index].childNodes[0].className.indexOf('btnSuo') > -1) {
    return false;
  }
  btnRef.value[index].childNodes[0].classList.add('animate__fadeOutUp', 'btnTextColor')
  btnRef.value[index].childNodes[0].addEventListener('animationend', () => {
    btnRef.value[index].childNodes[0].classList.remove('animate__fadeOutUp')
    btnRef.value[index].childNodes[0].classList.add('animate__fadeInUp', 'btnSuo', 'btnTextColor')
  });
}
const removeBtnClass = (index) => {
  btnRef.value[index].childNodes[0].classList.remove('animate__fadeInUp')
  btnRef.value[index].childNodes[0].classList.add('animate__fadeOutDown', 'btnTextColor')
  btnRef.value[index].childNodes[0].addEventListener('animationend', () => {
    btnRef.value[index].childNodes[0].classList.remove('animate__fadeOutDown', 'btnTextColor')
    btnRef.value[index].childNodes[0].classList.add('animate__fadeInDown')
    btnRef.value[index].childNodes[0].classList.remove('btnSuo')
  });
}
onMounted(() => {
  window.addEventListener('scroll', handleScroll);
  handleScroll()


})
onDeactivated(() => {
  window.removeEventListener('scroll', handleScroll, true);
})

</script>

<style scoped lang="less">
.none {
  display: none !important;
}

.btn {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  position: fixed;
  top: 0px;
  z-index: 10000;
  color: white;
}

.btnN {
  background-color: white !important;
  opacity: 1;
  color: #12466e;
}

.btnn {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: transparent;
  z-index: 5000;
  padding: 20px;
  box-sizing: border-box;
}


.btn2 {
  background-color: rgba(255, 255, 255, 1);
  height: 50px;
  animation: btnDong 1s;
  position: fixed;
  top: 0px;
  color: #12466e;
}

.btn3 {
  background-color: transparent;
  height: 90px;
  position: fixed;
  top: 0px;
  animation: btnDong2 1s;
  opacity: 1;
}

@keyframes btnDong {
  0% {
    background-color: transparent;
    height: 90px;
  }
  100% {
    background-color: rgba(255, 255, 255, 1);
    height: 50px;
  }
}

@keyframes btnDong2 {
  100% {
    background-color: transparent;
    height: 90px;
  }
  0% {
    background-color: white;
    height: 50px;
  }
}

.lang-box {
  position: relative;
  top: 0px;
  z-index: 2000;
}

.lang-box2 {
  margin-left: 20px;
  cursor: pointer;
  position: relative;
  top: 0px;
  z-index: 2000;
}

.lang-box2 {
  display: flex;
  height: 100%;
  align-items: center;
  cursor: pointer
}

.lang-box2-btn {
  display: flex;
  align-items: center;
  padding: 10px 0px;
  box-sizing: border-box
}

.scroll .lang-box {
  border: 1px solid #ddd
}

.lang-box a {
  background: 0 0;
  padding: 0 8px;
  display: inline-block
}

.lang-box a.active, .scroll .lang-box a.active {
  background: #fff;
}

.btnText {
  font-weight: 700;
  margin: 0 20px 0 20px;
  font-size: 18px;
  cursor: pointer;
}

.btnText2 {
  color: #f26228;
  font-weight: 700;
  margin: 0 20px 0 20px;
  font-size: 18px;
  cursor: pointer;
}

.animate__faster__btn {
  --animate-duration: 0.15s;
}

.btnTextColor {
  color: #f26228;
}

.btnH1 {
  position: absolute;
  top: 50%;
  margin: 0 10%;
  transform: translate(0%, -50%);
}

.zibtn {
  position: fixed;
  top: 0;
  background-color: white;
  width: 100%;
  animation: zibtn2 0.5s;
  z-index: 1000;
}

@keyframes zibtn2 {
  100% {
    top: 0px;
  }

  0% {
    top: -100%;
  }
}

.barzi:hover {
  color: #f26228;
}

.barzi2 {
  padding: 15px 30px;
  color: #666666;
  font-weight: 300;
  width: 100%;
  white-space: nowrap;

}

.barzi2:hover {
  color: #f26228;
}

.zibtnD {
  padding: 15px;
  display: flex;
  align-items: center;
  cursor: pointer;
  flex-wrap: wrap;
}

.zibtnDiv {
  display: flex;
  margin: 0 20%;
  padding: 30px 20px;
  box-sizing: border-box;
  justify-content: space-around;
  color: #555555;
  font-weight: 600;
  align-items: flex-start;
}

.you {
  width: 10px;
  margin-top: 10px;
  margin-right: 10px;
}

.icon1 {
  fill: #12466e;
  margin: 0px 10px;
}

.icon2 {
  fill: white;
  margin: 0px 10px;
}

.zi {
  padding: 8px 13px;
  cursor: pointer;
  font-size: 16px;
}

.zi:hover {
  color: #12466e;
  background-color: #ecf5ff;
}
</style>
